<div class="checkin__navbar__aditional__info__wrapper">
  <ng-container *ngFor="let item of items">
    <app-navbar-aditional-info-item [item]="item"></app-navbar-aditional-info-item>
  </ng-container>
</div>
